import storage from '@/store/storage'

const app = {
  state: {
    sidebar: {
      opened: !+storage.get('sidebarStatus')
    },
    device: 'desktop',
    alarmInfo: [],//报警信息
    notiNum: 0,//报警消息数量
    signData: [],//产生单位签约消息
    signiNum: 0,//产生单位签约数量
    vehicleSto: [], // 车辆实时
    menu: [],//菜单权限
    iframeToken:'' // 内嵌页面切换token
  },
  mutations: {
    setAlarmInfo(state, alarmInfo) {
      state.alarmInfo = alarmInfo
    },
    setNotiNum(state, notiNum) {
      state.notiNum = notiNum
    },
    setMenu(state, menu) {
      state.menu = menu
    },
    // 车辆实时信息
    setvehicleSto(state, vehicleSto) {
      state.vehicleSto = vehicleSto
    },
    // 产生单位签约信息
    setSignData(state, signData) {
      state.signData = signData
    },
    setSigniNum(state, signiNum) {
      state.signiNum = signiNum
    },
    setIframeToken(state, iframeToken) {
      console.log(iframeToken,'牛阿');
      state.iframeToken = iframeToken
    },

    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        storage.set('sidebarStatus', 1)
      } else {
        storage.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state) => {
      storage.set('sidebarStatus', 1)
      state.sidebar.opened = false
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
  },
  actions: {
    setMenu(context, menu) {
      context.commit('setMenu', menu);
    },
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }) {
      commit('CLOSE_SIDEBAR')
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setAlarmInfo({ commit }, alarmInfo) {
      commit('setAlarmInfo', alarmInfo)
    },
    setSignData({ commit }, SignData) {
      commit('setSignData', SignData)
    },
    setIframeToken({ commit }, setIframeToken) {
      commit('setIframeToken', setIframeToken)
    },
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js